<form [formGroup]="form" (ngSubmit)="salvar()">
  <div class="form-group row m-b">
    <div class="col-sm-8">
      <label class="col-sm-12 pb-1">Enunciado</label>
      <textarea id="title" class="form-control" rows="3" formControlName="title" placeholder="Enunciado do Indicador" maxlength="300"></textarea>
      <app-field-message [field]="fieldMessageRequired('title')" [erros]="fieldErros('title')"></app-field-message>
    </div>
  </div>

  <div class="form-group row m-b">
    <div class="col-sm-8">
      <label class="col-sm-12 pb-1">Descrição do Indicador</label>
      <textarea id="description" class="form-control" rows="4" formControlName="description" placeholder="Descrição do Indicador" maxlength="720"></textarea>
    </div>
  </div>

  <div class="form-group row m-b">
    <div class="col-sm-8">
      <label class="col-sm-12 pb-1">Finalidade do Indicador</label>
      <textarea id="description_goal" class="form-control" rows="4" formControlName="description_goal" placeholder="Descrição da Finalidade" maxlength="720"></textarea>
    </div>
  </div>

  <div class="form-group row m-b">
    <div class="col-sm-8">
      <label class="col-sm-12 pb-1">Unidade de Medida</label>
      <ng-select id="unit_id" class="ng-select-alternative" [items]="list?.unit_id" bindLabel="label" bindValue="id" placeholder="Selecione" formControlName="unit_id">
      </ng-select>
      <app-field-message [field]="fieldMessageRequired('unit_id')" [erros]="fieldErros('unit_id')"></app-field-message>
    </div>
  </div>

  <div class="form-group row m-b">
    <div class="col-sm-4">
      <label class="col-sm-12 pb-1">Meta total</label>
      <input id="goal" class="form-control text-right" formControlName="goal" (keyup)="formatarMedidaFisica('goal', form.get('decimal_places').value)">
      <app-field-message [field]="fieldMessageRequired('goal')" [erros]="fieldErros('goal')"></app-field-message>
    </div>
  </div>

  <div class="form-group row m-b year_projeto">
    <div class="col-sm-4">
      <label class="col-sm-12 pb-1">Mensuração - Ano Inicial</label>
      <input id="year_start" type="text" class="form-control" formControlName="year_start" maxlength="4" (keyup)="maskNumber($event, 'year_start')">
      <app-field-message [field]="fieldMessageRequired('year_start')" [erros]="fieldErros('year_start')"></app-field-message>
    </div>
  </div>

  <div class="form-group row m-b year_projeto">
    <div class="col-sm-4">
      <label class="col-sm-12 pb-1">Mensuração - Ano Final</label>
      <input id="year_end" type="text" class="form-control" formControlName="year_end" maxlength="4" (keyup)="maskNumber($event, 'year_end')">
      <app-field-message [field]="fieldMessageRequired('year_end')" [erros]="fieldErros('year_end')"></app-field-message>
    </div>
  </div>

  <div class="form-group row m-b">
    <div class="col-sm-8">
      <label class="col-sm-12 pb-1">Fonte dos dados</label>
      <textarea id="data_source" class="form-control" rows="4" formControlName="data_source" placeholder="Descrição da Fonte dos dados" maxlength="720"></textarea>
      <app-field-message [field]="fieldMessageRequired('data_source')" [erros]="fieldErros('data_source')"></app-field-message>
    </div>
  </div>

  <div class="form-group row m-b">
    <div class="col-sm-4">
      <label class="col-sm-12 pb-1">Responsável titular</label>
      <ng-select id="manager" class="ng-select-alternative" [items]="listUsuario" bindLabel="label" bindValue="id" placeholder="Selecione" formControlName="manager">
      </ng-select>
    </div>
  </div>

  <div class="form-group row m-b">
    <div class="col-sm-4">
      <label class="col-sm-12 pb-1">Responsável adjunto</label>
      <ng-select id="adjunct" class="ng-select-alternative" [multiple]="true" [items]="listUsuario" bindLabel="label" bindValue="id" placeholder="Selecione" formControlName="adjunct">
      </ng-select>
    </div>
  </div>

  <h4 class="mt-5 mb-3">Configuração da Tabela do Indicador</h4>

  <div class="form-group row m-b">
    <div class="col-sm-4">
      <label class="col-sm-12 pb-1">Tipo de tabela</label>
      <ng-select id="table_mod_id" class="ng-select-alternative" (change)="tableModRefresh($event)" [items]="list?.table_mod_id" bindLabel="label" bindValue="id" placeholder="Selecione" formControlName="table_mod_id">
      </ng-select>
    </div>
  </div>

  <div class="form-group row m-b" *ngIf="form.get('table_mod_id').value == 2">
    <div class="col-sm-4">
      <label class="col-sm-12 pb-1">Numerador</label>
      <input id="numerator_label" class="form-control" formControlName="numerator_label">
      <app-field-message [field]="fieldMessageRequired('numerator_label')" [erros]="fieldErros('numerator_label')"></app-field-message>
    </div>
  </div>

  <div class="form-group row m-b" *ngIf="form.get('table_mod_id').value == 2">
    <div class="col-sm-4">
      <label class="col-sm-12 pb-1">Denominador</label>
      <input id="denominator_label" class="form-control" formControlName="denominator_label">
      <app-field-message [field]="fieldMessageRequired('denominator_label')" [erros]="fieldErros('denominator_label')"></app-field-message>
    </div>
  </div>

  <div class="form-group row m-b">
    <div class="col-sm-4">
      <label class="col-sm-12 pb-1">Periodicidade</label>
      <ng-select id="period_mod_id" class="ng-select-alternative" [items]="list?.period_mod_id" bindLabel="label" bindValue="id" placeholder="Selecione" formControlName="period_mod_id">
      </ng-select>
      <app-field-message [field]="fieldMessageRequired('period_mod_id')" [erros]="fieldErros('period_mod_id')"></app-field-message>
    </div>
  </div>

  <div class="form-group row m-b" *ngIf="form.get('period_mod_id').value == 1 || form.get('period_mod_id').value == 2">
    <div class="col-sm-4">
      <label class="col-sm-12 pb-1">Primeiro mês de medição</label>
      <ng-select id="month1" class="ng-select-alternative" [items]="list?.month1" bindLabel="label" bindValue="id" placeholder="Selecione" formControlName="month1">
      </ng-select>
      <app-field-message [field]="fieldMessageRequired('month1')" [erros]="fieldErros('month1')"></app-field-message>
    </div>
  </div>

  <div class="form-group row m-b" *ngIf="form.get('period_mod_id').value == 2">
    <div class="col-sm-4">
      <label class="col-sm-12 pb-1">Segundo mês de medição</label>
      <ng-select id="month2" class="ng-select-alternative" [items]="list?.month2" bindLabel="label" bindValue="id" placeholder="Selecione" formControlName="month2">
      </ng-select>
      <app-field-message [field]="fieldMessageRequired('month2')" [erros]="fieldErros('month2')"></app-field-message>
    </div>
  </div>

  <div class="form-group row m-b">
    <div class="col-sm-4">
      <label class="col-sm-12 pb-1">Polaridade</label>
      <ng-select id="polarity" class="ng-select-alternative" [items]="list?.polarity" bindLabel="label" bindValue="id" placeholder="Selecione" formControlName="polarity">
      </ng-select>
      <app-field-message [field]="fieldMessageRequired('polarity')" [erros]="fieldErros('polarity')"></app-field-message>
    </div>
  </div>

  <div class="form-group row m-b">
    <div class="col-sm-4">
      <label class="col-sm-12 pb-1">Valores</label>
      <ng-select id="accum" class="ng-select-alternative" [items]="list?.accum" bindLabel="label" bindValue="id" placeholder="Selecione" formControlName="accum" (change)="accumChange()">
      </ng-select>
      <app-field-message [field]="fieldMessageRequired('accum')" [erros]="fieldErros('accum')"></app-field-message>
    </div>
  </div>

  <div class="form-group row m-b">
    <div class="col-sm-4">
      <label class="col-sm-12 pb-1">Casas decimais</label>
      <ng-select id="decimal_places" class="ng-select-alternative" [items]="list?.decimal_places" bindLabel="label" bindValue="id" placeholder="Selecione" formControlName="decimal_places" (change)="decimalChange()">
      </ng-select>
      <app-field-message [field]="fieldMessageRequired('decimal_places')" [erros]="fieldErros('decimal_places')"></app-field-message>
    </div>
  </div>

  <div class="form-group row m-b">
    <div class="col-sm-4">
      <label class="col-sm-12 pb-1">Mostrar total</label>
      <ng-select id="accum_show" class="ng-select-alternative" [items]="list?.accum_show" bindLabel="label" bindValue="id" placeholder="Selecione" formControlName="accum_show">
      </ng-select>
      <app-field-message [field]="fieldMessageRequired('accum_show')" [erros]="fieldErros('accum_show')"></app-field-message>
    </div>
  </div>

  <div class="form-group row m-b">
    <div class="col-sm-4">
      <label class="col-sm-12 pb-1">Mostrar visão composta</label>
      <ng-select id="accum_table" class="ng-select-alternative" [items]="list?.accum_table" bindLabel="label" bindValue="id" placeholder="Selecione" formControlName="accum_table" (change)="accumTableChange()">
      </ng-select>
      <app-field-message [field]="fieldMessageRequired('accum_table')" [erros]="fieldErros('accum_table')"></app-field-message>
    </div>
  </div>

  <div *ngIf="entity?.id">
    <h4 class="mt-5 mb-3">Configuração especificas</h4>

    <div class="form-group row m-b">
      <div class="col-sm-4">
        <label class="col-sm-12 pb-1">Percentagem padrão do Status ok</label>
        <input id="status_ok" type="text" class="form-control text-right" formControlName="status_ok" (keyup)="formatarMedidaFisica('status_ok')">
        <app-field-message [field]="fieldMessageRequired('status_ok')" [erros]="fieldErros('status_ok')"></app-field-message>
      </div>
    </div>

    <div class="form-group row m-b">
      <div class="col-sm-4">
        <label class="col-sm-12 pb-1">Percentagem padrão do Status atenção</label>
        <input id="status_warn" type="text" class="form-control text-right" formControlName="status_warn" (keyup)="formatarMedidaFisica('status_warn')">
        <app-field-message [field]="fieldMessageRequired('status_warn')" [erros]="fieldErros('status_warn')"></app-field-message>
      </div>
    </div>

    <div class="form-group row m-b">
      <div class="col-sm-4">
        <label class="col-sm-12 pb-1">Percentagem padrão do Status Atraso</label>
        <input id="status_alert" type="text" class="form-control text-right" formControlName="status_alert" (keyup)="formatarMedidaFisica('status_alert')">
        <app-field-message [field]="fieldMessageRequired('status_alert')" [erros]="fieldErros('status_alert')"></app-field-message>
      </div>
    </div>

    <div class="form-group row m-b">
      <div class="col-sm-4">
        <label class="col-sm-12 pb-1">Nível de Acompanhamento</label>
        <ng-select id="level_mon_id" class="ng-select-alternative" [items]="list?.level_mon_id" bindLabel="label" bindValue="id" placeholder="Selecione" formControlName="level_mon_id">
        </ng-select>
        <app-field-message [field]="fieldMessageRequired('level_mon_id')" [erros]="fieldErros('level_mon_id')"></app-field-message>
      </div>
    </div>

    <div class="form-group row m-b">
      <div class="col-sm-4">
        <label class="col-sm-12 pb-1">Indicador incompleto para acompanhamento</label>
        <ng-select id="disabled" class="ng-select-alternative" [items]="list?.disabled" bindLabel="label" bindValue="id" placeholder="Selecione" formControlName="disabled">
        </ng-select>
        <app-field-message [field]="fieldMessageRequired('disabled')" [erros]="fieldErros('disabled')"></app-field-message>
      </div>
    </div>
  </div>

  <div class="form-group row m-b" *ngIf="entity?.id">
    <div class="col-sm-4">
      <label class="col-sm-12 pb-1">Plano de Ação</label>
      <input type="text" class="form-control" value="O plano de ação da origem será copiado ao clonar" disabled>
    </div>
  </div>

  <div class="hr-line-dashed"></div>
  <div class="form-group row d-flex justify-content-end">
    <div class="col-sm-8 col-sm-offset-2 d-flex justify-content-end">
      <button class="btn btn-danger m-r-xxl" *ngIf="entity?.id && entity?.delete" (click)="confirmExcluir()" type="button">Excluir</button>
      <button class="btn btn-white m-r-xs" type="button" (click)="voltar()">Voltar</button>
      <button class="btn btn-primary" type="submit" *ngIf="!this.entity?.readonly">Salvar</button>
    </div>
  </div>
</form>
<br>
<app-historico-atualizacoes-list [audit]="audit"></app-historico-atualizacoes-list>
<app-loading [loader]="isLoading"></app-loading>